import { useEffect } from "react";
import { dispatchCusEvent, getParamFromUrl } from "../utils/utils";
import { useDispatch } from "react-redux";
import { setHardModeGame, setSessionId } from "../store/commonSlice";
import useFillCasino from "./common/useFillCasino";
import useNavigateWithSearch from "./useNavigateWitchSearch";
import useDeviceSizeFill from "./useDeviceSizeFill";
import { useLocalStorage, useReadLocalStorage } from "usehooks-ts";
import useMainPage from "./common/useMainPage";
import useFillLinks from "./common/useFillLinks";
import useListener, { ENUM_COMMON_EVENT } from "./common/useListener";
import useUrlParc from "./other/useUrlParc";
import { ENUM_LCS_NAME } from "../store/enums";
import useTawkController from "./other/useTawkController";
import useModalShowLogic from "./common/useModalShowLogic";
import useNewPasCheck from "./common/useNewPasCheck";
import useFillUser from "./useFillUser";

// useCommonHooks - основные хуки для
/**
  @description  основные небольшие хуки 
 */

export default function useCommonHooks() {
  useFillCasino();
  useFillLinks();
  useFillUser();
  useListener();
  useMainPage();
  useUrlParc();
  useTawkController();
  useModalShowLogic();
  useNewPasCheck();
  useDeviceSizeFill();

  const [saveGame, setSaveGame] = useLocalStorage(ENUM_LCS_NAME.saveGame);
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";

  const navigate = useNavigateWithSearch();
  const dispatch = useDispatch();
  // const location = useLocation();
  // const newPath = useGetLink(location.pathname);

  useEffect(() => {
    const sessionId = getParamFromUrl("sessionId");
    const mode = getParamFromUrl("mode");

    if (sessionId) dispatch(setSessionId(sessionId));
    if (mode) dispatch(setHardModeGame(mode));
  }, [window.location.search]);

  useEffect(() => {
    const path = saveGame?.path;
    if (!path) return;
    if (window.location.pathname == path) return;
    navigate(path);
    console.log("path", path);
    setSaveGame({});
  }, [navigate, saveGame]);

  useEffect(() => {
    dispatchCusEvent(ENUM_COMMON_EVENT.checkCaptcha);
  }, [start_r]);

  // useEffect(() => {
  //   window.history.pushState("", "", newPath);
  //   // console.log(newPath);
  // }, [newPath]);

  // useEffect(() => {
  //   if (isTgBot) return;
  //   dispatch(setModeGame(isAuth ? ENUM_MODE_GAME.real : ENUM_MODE_GAME.demo));
  // }, [isAuth, isTgBot]);
}
